export default __webpack_public_path__ + "static/media/Ben.7b7a1695.jpg";